import { types } from "../action-types";

const initialState = {
    loading: false,
    error: false,
    bid_types_count: [],
    all_bids_status: [],
    allBids: [],
    receivedBids: [],
    placedBids: [],
    favouriteBids: []

};

const getCandidatesReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.GET_CANDIDATES_REQUESTED:
            return {
                ...state,
                loading: true,
                bid_types_count: [],
                all_bids_status: [],
                allBids: [],
                receivedBids: [],
                placedBids: [],
                favouriteBids: []
            };

        case types.GET_CANDIDATES_SUCCESS:
            return {
                ...state,
                loading: false,
                bid_types_count: action.payload.bid_types_count,
                all_bids_status: action.payload.all_bids_status,
                allBids: action.payload.allBids,
                receivedBids: action.payload.receivedBids,
                placedBids: action.payload.placedBids,
                favouriteBids: action.payload.favouriteBids,
                error: false,
            };
        case types.GET_CANDIDATES_FAILURE:
            return {
                ...state,
                loading: false,
                bid_types_count: [],
                all_bids_status: [],
                allBids: [],
                receivedBids: [],
                placedBids: [],
                favouriteBids: [],
                error: true,
            };
        default:
            return state;
    }
};

export default getCandidatesReducer;
